// pages/index.tsx
import { FaStar } from "react-icons/fa";
import { GoLocation } from "react-icons/go";
import { Link } from "react-router-dom";

// Sample mock data
const farmers = [
  {
    name: "Namib Farmers",
    category: "Fruits & vegetables",
    location: "Nyika, Country",
    rating: "4.3(653)",
    link: "/communitypage1", // ✅ Added
    farmersCount: "12,001",
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745266762/image_40_fwioya.png",
  },
  {
    name: "Jamii Group",
    category: "Organic Herbs",
    location: "Nyika, Country",
    link: "/communitypage2", // ✅ Added
    rating: "4.7(891)",
    farmersCount: "8,412",
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745266650/image_pnnoi8.png",
  },
  {
    name: "Namib  Farmers",
    category: "Leafy Greens",
    location: "Nyika, Country",
    rating: "4.1(324)",
    link: "/communitypage3", // ✅ Added
    farmersCount: "10,130",
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745266649/image-1_bvg6ex.png",
  },
  {
    name: "Ubuntu  Farmers",
    category: "Root Vegetables",
    location: "Nyika, Country",
    rating: "4.5(712)",
    link: "/communitypage4", // ✅ Added
    farmersCount: "6,928",
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745266649/image-2_otvfuz.png",
  },
  {
    name: "Jamii Group",
    category: "Berries & Fruits",
    location: "Nyika, Country",
    link: "/communitypage5", 
    rating: "4.6(578)",
    farmersCount: "5,311",
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745266649/image-3_dgiefe.png",
  },
  {
    name: "Chama farmers",
    category: "Tropical Fruits",
    location: "Nyika, Country",
    rating: "4.2(199)",
    link: "/communitypage6", 
    farmersCount: "9,210",
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745266650/image-4_n5ywep.png",
  },
  {
    name: "Kundi Farmers",
    category: "Vegetables & Beans",
    location: "Nyika, Country",
    link: "/communitypage7", 
    rating: "4.8(1024)",
    farmersCount: "11,458",
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745266649/image-5_coxgau.png",
  },
  {
    name: "Maendeleo group",
    category: "Eco-friendly Produce",
    location: "Nyika, Country",

    link: "/communitypage8", 
    rating: "4.4(600)",
    farmersCount: "7,900",
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745266649/image-6_cfty74.png",
  },
  {
    name: "Gitega Community",
    category: "Dry Zone Crops",
    location: "Nyika, Country",
    link: "/communitypage9", 
    rating: "4.1(321)",
    farmersCount: "5,678",
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745266650/image-7_d8avkb.png",
  },
  {
    name: "Kigali  Farmers",
    category: "Mixed Farming",
    location: "Nyika, Country",
    rating: "4.6(879)",
    farmersCount: "13,900",
    link: "/communitypage10", 
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745266651/image-8_dt8xtk.png",
  },
  {
    name: "Zambezi  Farmers",
    category: "Hill Crops",
    location: "Nyika, Country",
    rating: "4.3(444)",
    link: "/communitypage11", 
    farmersCount: "6,210",
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745266650/image-9_zmrnfg.png",
  },
  {
    name: "Ujamaa  Farmers",
    category: "Seasonal Produce",
    location: "Nyika, Country",
    link: "/communitypage12", 
    rating: "4.9(987)",
    farmersCount: "14,120",
    image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745266650/image-10_wgwune.png",
  },
];

export default function Home() {
  return (
    <main className=" md:py-10 py-4 md:min-h-screen">
      <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-3 xl:grid-cols-3 gap-x-1 md:gap-y-10 gap-y-1 place-items-center">
        {farmers.map((farm, index) => (
          <Link to={farm.link} key={index} className="w-full max-w-[396px] rounded-md bg-white hover:shadow-xl transition duration-300">
            <div>
              <img
                src={farm.image}
                alt={farm.name}
                className="w-full md:h-[215px] h-[80px] object-cover rounded"
                style={{ borderRadius: "5px" }}
              />
              <div className="p-2">
                <div className="flex justify-between items-center ">
                  <h2 className="text-[#979797] font-bold  text-[6px] md:text-[20px]">{farm.name}</h2>
                  <div className="flex items-center">
                    <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744892528/star_hmxstj.png" alt="" className="md:w-[20px] md:h-[20px] w-[6px] h-[6px]" />
                    <span className="text-black font-bold text-[6px] md:text-[20px]">{farm.rating}</span>
                  </div>
                </div>

                <div className="flex justify-between text-black  text-[4px] md:text-[16px]">
                  <span className="font-extrabold">{farm.category}</span>
                  <div className="flex items-center mt-2">
                    <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744892528/image_1591_res4vm.png" alt="" className="md:w-[20px] md:h-[20px]  w-[6px] h-[6px]" />
                    <span className="font-extrabold">{farm.location}</span>
                  </div>
                </div>

                <div className="-mt-2 text-black font-normal text-[6px] md:text-[16px]">
                  Farmers : <span className="font-extrabold">{farm.farmersCount}</span>
                </div>
                <div className="flex justify-end md:-mt-3"> 
                  <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745269998/Expand_right_3_j7n2vo.png" alt="img" className="md:w-[24px] w-[6px] h-[6px] md:h-[24px]"/>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </main>
  );
}
